App.vue.setComponent(require('@components/Stocks/Stocks.vue').default);
